import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ul",
  "use": "icon-ul-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ul\"><circle cx=\"2.5\" cy=\"3.998\" r=\"2.5\" /><path d=\"M8.5 5H23a1 1 0 000-2H8.5a1 1 0 000 2z\" /><circle cx=\"2.5\" cy=\"11.998\" r=\"2.5\" /><path d=\"M23 11H8.5a1 1 0 000 2H23a1 1 0 000-2z\" /><circle cx=\"2.5\" cy=\"19.998\" r=\"2.5\" /><path d=\"M23 19H8.5a1 1 0 000 2H23a1 1 0 000-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol